/**
 * Helper for making Elements with attributes
 * @param tagName     - new Element tag name
 * @param classNames  - list or name of CSS class
 * @param attributes  - any attributes
 * @returns HTMLElement
 */
export function make(
  tagName: string,
  classNames: string[] | string | null = null,
  attributes: { [key: string]: string | boolean } = {}
): HTMLElement {
  const el = document.createElement(tagName);

  if (Array.isArray(classNames)) {
    el.classList.add(...classNames);
  } else if (classNames !== null) {
    el.classList.add(classNames);
  }

  for (const attrName in attributes) {
    if (attributes.hasOwnProperty(attrName)) {
      const value = attributes[attrName];

      // Convert boolean to string for attributes
      if (typeof value === "boolean") {
        el.setAttribute(attrName, value.toString());
      } else {
        el.setAttribute(attrName, value);
      }
    }
  }

  return el;
}
